"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconUploadAndSubmit = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M41.93 49.91h-4.07a1.6 1.6 0 0 1 0-3.2h4.07a3.1 3.1 0 0 0 0-6.2 3.07 3.07 0 0 0-1 .16 1.6 1.6 0 0 1-2-1 4.49 4.49 0 0 0-8.69 1.36A1.6 1.6 0 0 1 28 42.47a2.18 2.18 0 1 0-.86 4.19h4.64a1.6 1.6 0 0 1 0 3.2h-4.64a5.38 5.38 0 0 1 0-10.76h.19a7.69 7.69 0 0 1 14-1.77h.63a6.3 6.3 0 0 1 0 12.6z"
  }), _react["default"].createElement("path", {
    d: "M62.75 57.56H7.25A1.6 1.6 0 0 1 5.65 56V28.29a1.6 1.6 0 0 1 1.6-1.6h55.5a1.6 1.6 0 0 1 1.6 1.6V56a1.6 1.6 0 0 1-1.6 1.56zm-53.9-3.2h52.3V29.89H8.85zM24.54 24.27H7.25a1.6 1.6 0 0 1-1.6-1.6V14a1.6 1.6 0 0 1 1.6-1.6h17.29a1.6 1.6 0 0 1 1.6 1.6v8.63a1.6 1.6 0 0 1-1.6 1.64zm-15.69-3.2h14.09v-5.43H8.85zM47.58 24.27H30.29a1.6 1.6 0 0 1-1.6-1.6V14a1.6 1.6 0 0 1 1.6-1.6h17.29a1.6 1.6 0 0 1 1.6 1.6v8.63a1.6 1.6 0 0 1-1.6 1.64zm-15.69-3.2H46v-5.43H31.89z"
  })),
  height: undefined,
  width: undefined
});
IconUploadAndSubmit.displayName = 'IconUploadAndSubmit';
var _default = IconUploadAndSubmit;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/upload-and-submit.js
// module id = 600
// module chunks = 0